import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useToasts } from 'react-toast-notifications';
import * as ROUTES from '../../../constants/routes';
import { blogService } from '../../../services/blogService';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

export default function BlogCreate() {
  const history = useHistory();
  const { addToast } = useToasts();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    title: '',
    content: '',
    excerpt: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleQuillChange = (value) => {
    setFormData(prev => ({
      ...prev,
      content: value
    }));
  };

  const handleSummaryQuillChange = (value) => {
    setFormData(prev => ({
      ...prev,
      excerpt: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await blogService.createPost(formData);
      addToast('Blog post created successfully.', {
        appearance: 'success',
        autoDismiss: true,
      });
      history.push(ROUTES.ADMIN_BLOG);
    } catch (error) {
      addToast('Blog yazısı oluşturulurken bir hata oluştu.', {
        appearance: 'error',
        autoDismiss: true,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container">
      <div className="row mb-4">
        <div className="col">
          <h2>New Blog Post</h2>
        </div>
      </div>

      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="title">Title</label>
          <input
            type="text"
            className="form-control"
            id="title"
            name="title"
            value={formData.title}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="excerpt">Summary</label>
          <ReactQuill
            value={formData.excerpt}
            onChange={handleSummaryQuillChange}
            theme="snow"
            id="excerpt"
          />
        </div>

        <div className="form-group">
          <label htmlFor="content">Content</label>
          <ReactQuill
            value={formData.content}
            onChange={handleQuillChange}
            theme="snow"
            id="content"
          />
        </div>

        <div className="form-group">
          <button
            type="submit"
            className="btn btn-primary"
            disabled={loading}
          >
            {loading ? (
              <>
                <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true" />
                Saving...
              </>
            ) : (
              'Save'
            )}
          </button>
          <button
            type="button"
            className="btn btn-secondary ml-2"
            onClick={() => history.push(ROUTES.ADMIN_BLOG)}
            disabled={loading}
          >
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
} 